export default "__VITE_ASSET__BLq6wvsS__"